<template>
  <div class="aboutIdea">
    <div>
      <img src="../assets/images/idea_01.png" alt="">
      <div class="fz28">企业使命</div>
      <div class="fz18 c666">用我们的平台，让保险更简单阳光，成就更多人的幸福</div>
    </div>
    <div>
      <img src="../assets/images/idea_02.png" alt="">
      <div class="fz28">企业愿景</div>
      <div class="fz18 c666">成为中国最具亲和力的保险人终身事业平台</div>
    </div>
    <div>
      <img src="../assets/images/idea_03.png" alt="">
      <div class="fz28">团队文化</div>
      <div class="fz18 c666">自主·快乐·分享·成长·价值</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutIdea',
  components: {},
  data() {
    return {

    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.aboutIdea {
  width: 1200px;
  display: flex;
  justify-content: space-between;

  &>div {
    width: 360px;
    height: 298px;
    padding: 32px;
    background: #FFFFFF;
    box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    font-weight: 600;
    position: relative;

    .fz28 {
      color: #FFFFFF;
      position: absolute;
      top: 80px;
      left: 124px;
    }

    .fz18 {
      margin-top: 32px;
    }

    .center {
      height: 50px;
      line-height: 50px;
    }
  }

  img {
    width: 296px;
    height: 136px;
    background: rgba(0, 0, 0, 0.3);
  }
}
</style>